/** Unique identifier for a pinned widget: "channelKey::metricKey" */
export type WidgetId = `${string}::${string}`;

export interface PinnedWidget {
  id: WidgetId;
  channelKey: string;
  platform: string;
  metricKey: string;
}

export interface LayoutSection {
  channelKey: string;
  platform: string;
  visible: boolean;
  collapsed: boolean;
}

export interface DashboardView {
  id: string;
  name: string;
  layoutSections: LayoutSection[];
  pinnedWidgets: PinnedWidget[];
  widgetFilters: Record<string, string[] | null>;
  widgetOrder: Record<string, string[]>;
  /** When true, Shopify-section widgets exclude TikTok-Shop-originated orders. Default false. */
  excludeTikTokOrders?: boolean;
}

export interface DashboardPreferences {
  activeViewId: string;
  views: DashboardView[];
}

export const MAX_VIEWS = 5;

export function createWidgetId(channelKey: string, metricKey: string): WidgetId {
  return `${channelKey}::${metricKey}`;
}

export function parseWidgetId(id: WidgetId): { channelKey: string; metricKey: string } {
  const idx = id.indexOf('::');
  return { channelKey: id.slice(0, idx), metricKey: id.slice(idx + 2) };
}
